import { HOST_BBS, HOST_PAI, HOST_WEB } from '../../../const'

const _webConfig_ = window._webConfig_ || {}
const CONFIG = _webConfig_;

export default {
    CONFIG,
    // 链接配置
    appraiserIndexAdv: {
        pageKey     : '/biz/xs/jianding/appraiser/',
        posKey      : 'slider'
    },
    Urls: {
        help: `https://${HOST_PAI}/v1/Article/help.html`,
        aboutUs: 'https://xuanshang95.com/poster/pub/xsh-about',
        privacy: 'https://xuanshang95.com/poster/pub/xshapp-privacy',
        userAgreement: 'https://xuanshang95.com/poster/pub/xsh-user-agreement',
        // vipAgreement: 'https://xuanshang95.com/poster/pub/xsh-vip-agreement',
        shopOrders: `https://${HOST_BBS}/plugin.php?id=wei_shop&mod=myorders`,
        paiOrders: `https://${HOST_PAI}/v1/Member/mysucc.html`,
        developer: '/test/develop',
        address: `https://${HOST_PAI}/v1/Member/deliver_address.html`,
        sellerIndex: `https://${HOST_PAI}/v1/Seller/index.html`,
        appDownload: `https://${HOST_WEB}/poster/pub/xshapp/`
    }
}
